import React from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';
import waterAnimation from '../assets/water.json';

export const SPINNER_PATIENT_CLASS_NAME = 'loading_patient_spinner';
export const SPINNER_SMALL_CLASS_NAMES = 'loading_small_spinner';

const Wrapper = styled.div<{ isFullScreen?: boolean }>`
  width: 100%;
  height: ${(props) => props.isFullScreen ? '100vh' : '100%'};
  background-color: ${(props) => props.theme.colors.mercury};
  display: flex;
  align-items: center;
  justify-content: center;

  & .loading_patient_spinner {
    width: 100px;
    height: 100px;
  }

  & .loading_small_spinner {
    width: 40px;
    height: 40px;
  }

  & .lottie-container {
    width: 200px;
    height: 200px;
  }
`;

const Loading: React.FunctionComponent<IProps> = ({
  className,
  spinnerClassName = SPINNER_PATIENT_CLASS_NAME,
  isFullScreen = false,
  useLottie = true,
}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: waterAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  if (useLottie) {
    return (
      <Wrapper className={className} isFullScreen={isFullScreen}>
        <div className="lottie-container">
          <Lottie options={defaultOptions} />
        </div>
      </Wrapper>
    );
  }

  // Fallback to old spinner
  return (
    <Wrapper className={className} isFullScreen={isFullScreen}>
      <div className={spinnerClassName}>
        Loading...
      </div>
    </Wrapper>
  );
};

export default Loading;

interface IProps {
  className?: string;
  spinnerClassName?: string;
  isFullScreen?: boolean;
  useLottie?: boolean;
}
